export default{caption:"w_Dq",isMonospace:"w_Dr",weight400:"w_Ds",weight700:"w_Dt"};
